import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
// Initialize MSAL instance variables
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and render app
msalInstance.initialize().then(() => {
    // Optional - This will enable account selection if a user has multiple accounts signed in.
    return msalInstance.handleRedirectPromise();
}).then((tokenResponse) => {
    // 1️⃣ If coming back from login redirect, use THAT account
    if (tokenResponse?.account) {
        msalInstance.setActiveAccount(tokenResponse.account);
    }
    // 2️⃣ If no tokenResponse, we do NOT set an active account automatically.
    // This forces the user to interactively sign in if they aren't already redirect-processed.
    // We do NOT use msalInstance.getAllAccounts()[0] anymore.

    msalInstance.enableAccountStorageEvents();

    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
            msalInstance.setActiveAccount(event.payload.account);
        }
    });

    const root = createRoot(document.getElementById('root'));
    root.render(
        <App instance={msalInstance} />
    );
});
